const titleColor = "#292A33";
const headingBackgroundColor = "transparent";
const bodyBackgroundColor = "transparent";

export const fallbackValues = {
  titleColor,
  headingBackgroundColor,
  bodyBackgroundColor
};
